export const SET_TICKET = "SET_TICKET";
export const SET_TICKETS = "SET_TICKETS";
export const SET_NEW_TICKETS = "SET_NEW_TICKETS";
export const ADD_TICKET = "ADD_TICKET";
export const SHOW_TICKET_DETAIL = "SHOW_TICKET_DETAIL";
export const HIDE_TICKET_DETAIL = "HIDE_TICKET_DETAIL";
export const SHOW_TICKET_DETAIL_SECTION = "SHOW_TICKET_DETAIL_SECTION";
export const UPDATE_TICKET = "UPDATE_TICKET";
export const REMOVE_TICKET = "REMOVE_TICKET";
export const UNSUBSCRIBE_GET_ALL_NEW_TICKETS = "UNSUBSCRIBE_GET_ALL_NEW_TICKETS";
export const SET_TICKET_DOWNLOADS = "SET_TICKET_DOWNLOADS";
export const ADD_TICKET_DOWNLOAD = "ADD_TICKET_DOWNLOAD";
export const UPDATE_TICKET_DOWNLOAD = "UPDATE_TICKET_DOWNLOAD";
export const REMOVE_TICKET_DOWNLOAD = "REMOVE_TICKET_DOWNLOAD";
export const UNSUBSCRIBE_GET_TICKET = "UNSUBSCRIBE_GET_TICKET";
export const SET_TICKETS_BY_STATE = "SET_TICKETS_BY_STATE";
export const UPDATE_TICKETS_BY_STATE = "UPDATE_TICKETS_BY_STATE";
export const REMOVE_TICKETS_BY_STATE = "REMOVE_TICKETS_BY_STATE";
